// extracted by mini-css-extract-plugin
module.exports = {"Violet_Button":"Button2_Violet_Button__2cht-"};